"use client";

import { c as _c } from "react/compiler-runtime";
import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";
import { repararCorpoTravado } from "@/lib/corpo-travado";

/**
 * Espera antes de julgar (ms). Maior que a animação de saída dos modais: no
 * meio do fechamento o body AINDA está travado e a camada ainda está no DOM
 * com `data-state="closed"` — julgar ali seria correr contra o próprio Radix.
 */
export const ESPERA_ANTES_DE_REPARAR_MS = 400;

/**
 * Devolve o controle da página quando um modal fecha e deixa o body travado
 * (CHAT002-4515). Montado uma vez na raiz: vale para toda tela.
 *
 * Observa o body — atributos (a trava) e filhos (os portais dos modais entram
 * e saem como filhos dele) — e, a cada mudança, espera a animação terminar e
 * pergunta a `repararCorpoTravado` se sobrou trava sem dono. Quando sobra,
 * remove e registra `corpo_travado_reparado` no PostHog: é o número que não
 * existia, porque esta falha não gera exceção, não gera 5xx e não aparece em
 * log nenhum.
 */
export function CorpoTravadoReparador() {
  const $ = _c(3);
  const posthog = usePostHog();
  let t0;
  let t1;
  if ($[0] !== posthog) {
    t0 = () => {
      let temporizador;
      const verificar = () => {
        clearTimeout(temporizador);
        temporizador = setTimeout(() => {
          const resultado = repararCorpoTravado(document);
          if (resultado.reparou) {
            posthog?.capture("corpo_travado_reparado", {
              caminho: window.location.pathname,
              pointer_events_travado: resultado.pointerEventsTravado,
              travas_de_scroll: resultado.travasDeScroll
            });
          }
        }, ESPERA_ANTES_DE_REPARAR_MS);
      };
      const observador = new MutationObserver(verificar);
      observador.observe(document.body, {
        attributes: true,
        attributeFilter: ["style", "data-scroll-locked"],
        childList: true
      });
      verificar();
      return () => {
        observador.disconnect();
        clearTimeout(temporizador);
      };
    };
    t1 = [posthog];
    $[0] = posthog;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}